import { useEffect } from "react"

import { useTranslation } from "@l2r-front/l2r-i18n"
import { Campaign } from "@l2r-front/l2r-proptypes"
import { I18N_NAMESPACE } from "@l2r-front/l2r-shared-campaign"
import { useIsMobileDevice } from "@l2r-front/l2r-ui"

import { CampaignCard } from "../../components/CampaignCard"
import { useCampaignDispatchContext } from "../../contexts/CampaignContext"

import * as Styled from "./CampaignList.styled"

export interface CampaignListProps {
    className?: string
    campaigns?: Campaign[]
    hoverHandling?: boolean
    isError?: boolean
    isLoading?: boolean
}

export function CampaignList(props: CampaignListProps) {

    const { t } = useTranslation([I18N_NAMESPACE])
    const {
        className,
        campaigns,
        hoverHandling = false,
        isError,
        isLoading,
    } = props

    const { setHoveredCampaign } = useCampaignDispatchContext()
    const isMobile = useIsMobileDevice()

    useEffect(() => {
        return () => {
            setHoveredCampaign(null)
        }
    }, [setHoveredCampaign])

    if (isError) {
        return <div>
            {t(I18N_NAMESPACE, "containers.campaignList.error")}
        </div>
    }

    if (isLoading) {
        return <Styled.Skeleton />
    }

    if (!campaigns?.length) {
        return <div>
            {t(I18N_NAMESPACE, "containers.campaignList.emptyList")}
        </div>
    }

    return <Styled.CampaignListContainer className={className}>
        {campaigns.map((campaign) => (
            <CampaignCard
                key={campaign.id}
                campaign={campaign}
                onMouseEnter={() => {
                    if (!isMobile && hoverHandling) {
                        setHoveredCampaign(campaign)
                    }
                }}
                onMouseLeave={() => {
                    if (!isMobile && hoverHandling) {
                        setHoveredCampaign(null)
                    }
                }}
            />
        ))}
    </Styled.CampaignListContainer>
}